// Progress photos (admin/progress-photos) — migrated to the OpenAPI-generated client.
//
// The legacy functions returned the RAW axios response; consumers read `response.data.body`
// (the HttpResponse envelope's paged body) for the list, and treat the rest as fire-and-
// forget. The SDK's `data` == the old `response.data`, so each returns `{data}`. The list
// endpoint takes FLAT pageId/pageSize query params (not a nested Spring Pageable), so it is
// safe to serialize through the SDK. Auth + X-Timezone come from configureApi's interceptor.

import {
    adminProgressPhotoControllerGetPhotos,
    adminProgressPhotoControllerAddPhoto,
    adminProgressPhotoControllerDeletePhoto,
    adminProgressPhotoControllerDeletePhotosByDate,
    adminProgressPhotoControllerSaveDateComment,
} from "../api/generated";

export async function getProgressPhotos(traineeId, pageId, pageSize) {
    const {data, error} = await adminProgressPhotoControllerGetPhotos({
        path: {traineeId},
        query: {pageId, pageSize},
    });
    if (error) throw error;
    return {data};
}

export async function addProgressPhoto(traineeId, photoUrl, photoDate) {
    const {data, error} = await adminProgressPhotoControllerAddPhoto({
        path: {traineeId},
        body: {photoUrl, photoDate},
    });
    if (error) throw error;
    return {data};
}

export async function deleteProgressPhoto(traineeId, photoId) {
    const {data, error} = await adminProgressPhotoControllerDeletePhoto({
        path: {traineeId, photoId},
    });
    if (error) throw error;
    return {data};
}

export async function deleteProgressPhotosByDate(traineeId, photoDate) {
    const {data, error} = await adminProgressPhotoControllerDeletePhotosByDate({
        path: {traineeId, photoDate},
    });
    if (error) throw error;
    return {data};
}

export async function saveDateComment(traineeId, photoDate, comment) {
    const {data, error} = await adminProgressPhotoControllerSaveDateComment({
        path: {traineeId},
        body: {photoDate, comment},
    });
    if (error) throw error;
    return {data};
}
